export enum FigureUltimateStatus {
    ULTIMATE,
    NONE
}